import { render, staticRenderFns } from "./SalesTaxActionButtons.vue?vue&type=template&id=a37042b0&scoped=true"
import script from "./SalesTaxActionButtons.vue?vue&type=script&lang=js"
export * from "./SalesTaxActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37042b0",
  null
  
)

export default component.exports